import { createApp } from 'vue';
import initStore from './stores/index';
import { initRouter } from './router';
import { getWebsiteAndCountry, boot } from './util/boot';
import { setGlobalProps } from './util/global-props';
import { register } from './plugins/element';
import { useGlobalStore } from './stores/global';
import { initTranslations } from './util/i18n';
import App from './app.vue';

document.querySelector('#app')!.append('.');
const websiteDetection = getWebsiteAndCountry();
const app = createApp(App);

const router = await initRouter(websiteDetection.prefix, websiteDetection.website);
const store = initStore(websiteDetection.website);
const i18n = await initTranslations(websiteDetection);

app.use(store);
app.use(router);
app.use(i18n);
const globalStore = useGlobalStore();
globalStore.websiteStore.initLanguage();

register(app);
setGlobalProps(app);
await boot(app, websiteDetection);
app.mount('#app');
console.log('APP', app, '\nSTORE', globalStore);
